<section class="topup-section container">
  <div class="row">
    <div class="small-12 columns">
      <h1 class="text-bold text-light-black" i18n="Summarize">Podsumowanie</h1>
    </div>
  </div>
  <section class="topup-section container">
    <div class="row align-center">
      <div class="topup-container small-12 large-5 columns text-center">

        @if (paymentStatus) {
          <div class="topup-summary topup-summary-success inner-wrapper">
            <div class="status">
              <span class="icon" [ngClass]="paymentSuccess ? 'icon-tick-new' : 'icon-cross-new'"></span>
            </div>
            @if (paymentSuccess) {
              <div>
                @if (rechargeAmount) {
                  <div>
                    <h2 i18n="ThankYouForPaymentAmount" class="no-margin-bottom half-base-margin-top">Dziękujemy za doładowanie kwotą:</h2>
                    <p class="amount-base"><strong>{{ rechargeAmount }} zł</strong></p>
                  </div>
                }
                @if (!rechargeAmount) {
                  <h2 i18n="ThankYouForPaymentNoAmount" class="no-margin-bottom half-base-margin-top">Dziękujemy za doładowanie</h2>
                }
                @if (rechargeGiftAmount) {
                  <div class="badge-yellow" hidden>
                    <span class="icon icon-gift-2"></span>
                    <p i18n="ThankYouGift" class="no-margin-bottom">
                Dodatkowo na Twoje <br>
                konto dodaliśmy <strong class=""> {{ rechargeGiftAmount }} zł</strong>,<br>
                które możesz wykorzystać <br>
                na rozmowy i SMS-y.
              </p>
                  </div>
                }
                @if (rechargeValidation) {
                  <p i18n="accountValidTime"
                    class="half-base-margin-top no-margin-bottom">
              Ważność konta:<strong class=""> {{ rechargeValidation }}</strong>
            </p>
                }
              </div>
            }
            @if (paymentStatusMessage) {
              <p
                class="half-base-margin-top no-margin-bottom"
              [innerHtml]="paymentStatusMessage"></p>
            }
          </div>
        }

        @if (!paymentStatus && paymentBlikInstrument) {
          <div class="topup-payment inner-wrapper">
            <img class="blik-logo" src="assets/images/payment_blik.svg" alt="BLIK">
            <img src="assets/images/loader.gif" alt="loader" style="display: block; margin: 1rem auto;"/>
            <div class="blik-message text-center">
              <p i18n="ConfirmTransaction">Zatwierdź transakcję<br class="hide-for-medium"> na swoim urządzeniu.</p>
            </div>
          </div>
        }

        @if (!paymentStatus && !paymentBlikInstrument) {
          <div class="topup-summary inner-wrapper">
            <img src="assets/images/loader.gif" alt="loader"/>
          </div>
        }
      </div>
    </div>
  </section>
</section>
